/**
 * DS-WMS Works Management System Module
 * Comprehensive works management dashboard with multiple views
 */

import type { Module } from '@/modules/index';
import { wmsFullscreenRoutes, wmsLegacyRoutes, wmsRoutes } from './routes';

const dsWmsModule: Module = {
  name: 'ds-wms',
  path: '/app/ds-wms',
  // Fullscreen route first so /app/ds-wms/pushkaralu resolves to the standalone
  // (no-sidebar) dashboard rather than the WmsShell layout.
  routes: [wmsFullscreenRoutes, wmsRoutes, wmsLegacyRoutes]
};

export default dsWmsModule;
